import * as React from "react";

export const IconRightShortArrow = (props: any) => (
  <svg
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="#251F2C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.37182 0.383314C2.1135 0.135286 1.78474 0 1.39726 0C0.62231 0 0 0.586245 0 1.33033C0 1.70237 0.164384 2.04059 0.434443 2.29989L8.65362 10.0113L0.434443 17.7001C0.164384 17.9594 0 18.3089 0 18.6697C0 19.4138 0.62231 20 1.39726 20C1.78474 20 2.1135 19.8647 2.37182 19.6167L11.5068 11.0485C11.8356 10.7554 11.9883 10.3946 12 10C12 9.60541 11.8356 9.26719 11.5068 8.9628L2.37182 0.383314Z" />
  </svg>
);
